import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postBillingReportDetail } from '../../../../actions';
import { BILLING_REPORT_DETAIL_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import BillReportDetailForm from './BillReportDetailForm';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';

const NewBillReportDetail = ({
  breadcrumbs,
  dispatchPostBillingReportDetail,
}) => {
  const onSubmit = (formValues) => {
    const fromDate = tzNormalizeDate({
      date: formValues.fromDateString,
      format: DATE_FORMAT,
    });

    const toDate = tzNormalizeDate({
      date: formValues.toDateString,
      format: DATE_FORMAT,
    });

    dispatchPostBillingReportDetail(fromDate, toDate);
  };

  const content = <BillReportDetailForm onSubmit={onSubmit} />;
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Reporte de Ventas e Ingresos Detallado"
      subtitle="Crear nuevo reporte de ventas e ingresos detallado."
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchPostBillingReportDetail: postBillingReportDetail,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Registro de Ventas e Ingresos',
      href: BILLING_REPORT_DETAIL_PATH,
    },
    {
      text: 'Nuevo banco',
      href: '',
    },
  ],
});

NewBillReportDetail.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBillingReportDetail: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewBillReportDetail);
